function getCompanyPubr(state) {
  return {
    // PublisherData Selectors
    data: state.usuarios.myCompany.data,
    loadingData: state.usuarios.myCompany.loadingData,
    fetchedData: state.usuarios.myCompany.fetchedData,
    fetchErrorData: state.usuarios.myCompany.fetchErrorData,

    // Config Selectors
    config: state.usuarios.myCompany.config,
    loadingConfig: state.usuarios.myCompany.loadingConfig,
    fetchedConfig: state.usuarios.myCompany.fetchedConfig,
    fetchErrorConfig: state.usuarios.myCompany.fetchErrorConfig,
    successConfig: state.usuarios.myCompany.successConfig,
    errorConfig: state.usuarios.myCompany.errorConfig,

    // Branches Selectors
    branches: state.usuarios.myCompany.branches,
    loadingBranches: state.usuarios.myCompany.loadingBranches,
    fetchedBranches: state.usuarios.myCompany.fetchedBranches,
    fetchErrorBranches: state.usuarios.myCompany.fetchErrorBranches,
    successBranches: state.usuarios.myCompany.successBranches,
    successEnabled: state.usuarios.myCompany.successEnabled,
    errorBranches: state.usuarios.myCompany.errorBranches,

    // Agent Selectors
    agent: state.usuarios.myCompany.agent,
    loadingAgent: state.usuarios.myCompany.loadingAgent,
    fetchedAgent: state.usuarios.myCompany.fetchedAgent,
    fetchErrorAgent: state.usuarios.myCompany.fetchErrorAgent,

    // Autologin Selectors
    autologin: state.usuarios.myCompany.autologin,
    loadingAutologin: state.usuarios.myCompany.loadingAutologin,
    fetchedAutologin: state.usuarios.myCompany.fetchedAutologin,
    fetchErrorAutologin: state.usuarios.myCompany.fetchErrorAutologin,
    autologinFetchOneTimeOnly: state.usuarios.myCompany.autologinFetchOneTimeOnly,

    // User Selectors
    users: state.usuarios.myCompany.users,
    loadingUsers: state.usuarios.myCompany.loadingUsers,
    fetchedUsers: state.usuarios.myCompany.fetchedUsers,
    fetchErrorUsers: state.usuarios.myCompany.fetchErrorUsers,

    // Change Password User
    userPassword: state.usuarios.myCompany.userPassword,
    loadingUserPassword: state.usuarios.myCompany.loadingUserPassword,
    errorUserPassword: state.usuarios.myCompany.errorUserPassword,

    // Common Selectos
    sentData: state.usuarios.myCompany.sentData,
    path: state.usuarios.myCompany.path,
    generalDispatch: state.usuarios.myCompany.generalDispatch,
    modal: state.usuarios.myCompany.modal,
    owner: state.usuarios.myCompany.owner,
    loading:
      state.usuarios.myCompany.loadingBranches ||
      state.usuarios.myCompany.loadingUsers ||
      state.usuarios.myCompany.loadingConfig ||
      state.usuarios.myCompany.loadingUserPassword,

    // commission shared selectors
    sharedCommission: state.usuarios.myCompany.sharedCommission,
    loadingSharedCommission: state.usuarios.myCompany.loadingSharedCommission,
    fetchedSharedCommission: state.usuarios.myCompany.fetchedSharedCommission,
    errorSharedCommission: state.usuarios.myCompany.errorSharedCommission,
    // share commission delete
    deletingCommissionShare: state.usuarios.myCompany.deletingCommissionShare,
    commissionShareDeleteCompleted: state.usuarios.myCompany.commissionShareDeleteCompleted,
    errorDeletingCommissionShare: state.usuarios.myCompany.errorDeletingCommissionShare,
    // save
    settingCommissionShare: state.usuarios.myCompany.settingCommissionShare,
    commissionShareCompleted: state.usuarios.myCompany.commissionShareCompleted,
    errorSettingCommissionShare: state.usuarios.myCompany.errorSettingCommissionShare
  };
}

export { getCompanyPubr };
